"use strict";
import { destroyObjectAttributes } from "./utils/memory/Utils-Memory";
//CSS
import { createHtmlNodeFeedback } from "./utils/rendering/Utils-Html-Rendering.mjs";

/** Class representing a Feedback. it defines a feedback
 * @property {function} question  - reference to the question concerned or activity if global.
 * @property {Integer} style      - feedback's style
 * @property {function} functionCallbackFeedback - callback function called when feedback is triggered.
 * @property {Boolean} isDefault                 - default feedback or not
 * @property {Node} htmlNode               - Node to display in the HTML
 */

export class Feedback {
  question;
  style;
  functionCallbackFeedback;
  defaultFeedback;
  htmlNode;
  disabled;

  constructor(question, functionCallbackFeedback, defaultFeedback = 0) {
    Activity.instances.push(this);
    this.question = question;
    this.style = { color: "black", size: "medium", alignment: "left" };
    this.functionCallbackFeedback = functionCallbackFeedback;
    this.default = defaultFeedback;
    this.disabled = false;
  }
  destroy() {
    destroyObjectAttributes(this);
  }
  isDefault() {
    return this.default;
  }

  isDisabled() {
    return this.disabled;
  }

  disable() {
    this.disabled = true;
  }

  render(node) {
    if (!this.disabled) {
      this.htmlNode = createHtmlNodeFeedback(null, 10);
      try {
        this.functionCallbackFeedback(this.question);
      } catch (e) {
        console.log("Impossible to generate feedback", e);
        let nodeText = document.createTextNode(
          "Impossible to generate feedback",
          e
        );
        this.htmlNode.appendChild(nodeText);
      }
    }
  }
}
/* ANIMATION
  export class Feedback_Global_DefaultSolutionFound extends Feedback_Global {
    //This var is static because used from Eleda code generated
    static defaultMessage = 'Bravo, tu as trouvé toutes les réponses 🤩'
    flyingRobot =  `
    <div id="animationSpaceshift" class="container">
    <audio
    autoplay src="../styles/eleda4teachers/animations/UFO-Landing-SoundBible.com-1015457638.mp3">
    </audio>
    <div class="spaceship">
    <div id="star1"></div>
    <div id="star2"></div>
    <div id="star3"></div>
    <div class="robot">
    <div id="half">
    <div id="brain"></div>
    </div>
    <div id="head">
    <span id="lc"></span><span id="le"></span><span id="re"></span>
    <div id="mouth"></div>
    <span id="rc"></span>
    </div>
    <div id="foot"></div>
    <div id="leg-1"></div>
    <div id="leg-2"></div>
    </div>
    <div class="spaceship_top"></div>
    <div class="spaceship_middle">
    <div class="spaceship_balls_1"></div>
    <div class="spaceship_balls_2"></div>
    <div class="spaceship_balls_3"></div>
    <div class="spaceship_balls_4"></div>
    <div class="spaceship_balls_5"></div>
    </div>
    <div class="spaceship_bottom">
    <div class="abduct_hole1"></div>
    <div class="abduct_hole2"></div>
    <div class="abduct_hole3"></div>
    <div class="abduct_hole4"></div>
    <div class="abduct_hole5"></div>
    </div>
    </div>
    </div>
    `

    constructor(conditionFunction){
      super(Feedback_Global_DefaultSolutionFound.defaultMessage, conditionFunction)
  //this.parser = new DOMParser();
}

getHtmlNode(){
    //Animation
    //
    //Activate spaceship animation only for non debug code
    if (!DEBUG) {
      var animationNode = createNodeFromHtmlString(this.flyingRobot);
      document.getElementById("animations").appendChild(animationNode)
      setTimeout(function(animationNode){
        document.getElementById("animationSpaceshift").remove()    
      }, 8000)
    }
    return super.getHtmlNode()
  }
}
*/
